import React, {useEffect } from "react";
import firebase from '../../utils/firebase';
import { useSelector,useDispatch } from 'react-redux';
import { useState } from 'react';
import logo from '../../assets/imagenes/logo.png';
import "./index.css";
import Clientes from '../../containers/Clientes';
import Captura from '../../containers/Captura';
import Tickets from '../../containers/Tickets';
import Password from '../../containers/Password';
import Dialog from '@mui/material/Dialog'; //actualizacion nodejs
import DialogActions from '@mui/material/DialogActions'; //actualizacion nodejs
import DialogContent from '@mui/material/DialogContent'; //actualizacion nodejs
import DialogContentText from '@mui/material/DialogContentText'; //actualizacion nodejs
import DialogTitle from '@mui/material/DialogTitle'; //actualizacion nodejs
import {  getVendedor, getClientes, getConfiguracion, getTickets, getFacturas, getVendedores } from '../API'
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper'; //actualizacion nodejs
import Drawer from '@mui/material/Drawer'; //actualizacion nodejs
import CssBaseline from '@mui/material/CssBaseline'; //actualizacion nodejs
import AppBar from '@mui/material/AppBar'; //actualizacion nodejs
import Toolbar from '@mui/material/Toolbar'; //actualizacion nodejs
import List from '@mui/material/List'; //actualizacion nodejs
import Typography from '@mui/material/Typography'; //actualizacion nodejs
import Divider from '@mui/material/Divider'; //actualizacion nodejs
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button'; //actualizacion node js
import CircularProgress from '@mui/material/CircularProgress'; //actualizacion node js
import { makeStyles } from '@mui/styles';
import 'moment/locale/es';

const drawerWidth = -240;
const Root = styled('div')(({ theme }) => ({
  display: 'flex',
}));

const CustomAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }), 
}));

const CustomDrawer = styled(Drawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    width: drawerWidth,
  },
}));

const DrawerHeader = styled('div')(({ theme }) =>({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

const CustomMain = styled('main', {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    minHeight: typeof window !== 'undefined' ? window.innerHeight - 100 : 'auto',
    height: 'auto',
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
        transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }));

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
}));


export default function PersistentDrawerLeft() {
  const theme = useTheme();
  const [setTheme] = useState(true);
  const classes = useStyles();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [open, setOpen] = useState(false);
  const {syncs} =  useSelector((state)=>{ return state })
  const [vendedor, setVendedor] = useState(syncs.vendedor);
  const [clienteCobrar, setClienteCobrar] = useState(syncs.clienteCobrar);
  const [pantalla, setPantalla] = useState('Inicio');
  let { configuracion } = syncs;
  var user = vendedor;
  const [openSesion, setOpenSesion] = useState(false);
  const dispatch  = useDispatch();
  let puedeActualizar = false;//configuracion && configuracion.last_sync? moment(moment()).isAfter( moment(configuracion.last_sync), 'day') && moment(configuracion.last_sync).format('HH:mm:ss') >"07:00" ? false:true: false;
  
  const appliedTheme = createTheme({
    palette: {
      mode: isDarkMode ? 'dark' : 'light',
      primary:{
        main: '#3f51b5',
      }
    },
  });

  const handleThemeToggle = () => {
    setIsDarkMode(!isDarkMode);
  };
  
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  
  useEffect(() => {
    setVendedor(syncs.vendedor);
    setClienteCobrar(syncs.clienteCobrar);
  }, [syncs] );

  useEffect(()=>{
    if (clienteCobrar){
      setPantalla('Cobranza');
    }
  }, [clienteCobrar])

  const handleDrawerClose = () => {
    setOpen(false);
  };

  // Sustituye prop disable drop click
  const handleClose = (event, reason) => { 
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    setOpenSesion(false);
  };


  function cambioPantalla(text){
    setPantalla(text); 
    setOpen(false); 
    dispatch({type:"CLIENTE_COBRAR", payload: { clienteCobrar:null } })
  }

  useEffect(()=>{
    dispatch({type:"CLIENTE_COBRAR", payload: { clienteCobrar:null } });
    // const msg=firebase.messaging();
    // msg.requestPermission().then(()=>{
    //   return msg.getToken();
    // }).then((data)=>{
    //   console.log("token",data)
    // }).catch((err) => {
    //     console.log('An error occurred while retrieving token. ', err);
    //   });
    // const messaging=firebase.messaging();
    // messaging.usePublicVapidKey("BAQ-ovqOuw5lb0Kh558oqadY3lrIfBMFIbGl6Zk7Qzyn-KvM6TzlO84XHMfOtSNJXkmf4UL9LTLRe7t-nI1VbJQ");
    // messaging.getToken().then((currentToken) => {
    //   if (currentToken) {
    //     console.log(currentToken)
    //   } else {
    //     // Show permission request.
    //     console.log('No Instance ID token available. Request permission to generate one.');
    //     // Show permission UI.
    //   }
    // }).catch((err) => {
    //   console.log('An error occurred while retrieving token. ', err);
    // });
  }, [])

  const getInformation = async () =>{
    dispatch({type:"FETCHING_START"})
    let numero = await getVendedor(user.email);
    if( numero.VKBUR ){
      dispatch({type:"VENDEDOR_LOGIN", payload: { login:true, email: user.email, uid: user.uid, 
      numero_vendedor: numero.KUNNR, vendedor_nombre: numero.NAME1, VKBUR: numero.VKBUR, VKORG: numero.VKORG} })
      let configuracion = await getConfiguracion();
      dispatch({type:"CONFIGURACION_FETCHING", payload: { configuracion } })
      let clientes = await getClientes(numero.VKBUR);
      //console.log(clientes)
      dispatch({type:"CLIENTES_FETCHING", payload: { clientes } })
      let tickets = await getTickets(numero.KUNNR);
      dispatch({type:"TICKETS_FETCHING", payload: { tickets } })
      dispatch({type:"FETCHING_END"})
      setTimeout(function() { 
        dispatch({type:"CLIENTES_FETCHING", payload: { clientes } })
      }, 2000); 
    }else{
      await firebase.auth().signOut();
      dispatch({type:"FETCHING_END"})
    }
    // let a = await getVendedores()
    // console.log(a)
  };

  const getFacts = async () =>{
    let { clientes } = syncs;
    let newData = clientes;
    let flag = false;
    dispatch({type:"FETCHING_START"})
    var getNewFacts = new Promise((resolve, reject) => {
      newData.forEach(async (cliente, index, array) => {
        let ultimaFactura = ""
        if ( cliente.facturas && cliente.facturas.length > 0){
          ultimaFactura = cliente.facturas.reduce(function(prev, current) {
            return (prev.BELNR > current.BELNR) ? prev : current
          })
          ultimaFactura = ultimaFactura.BELNR
        }
        let facts = await getFacturas(cliente.KUNNR, ultimaFactura)
        if ( facts && facts.length > 0){
          flag = true
          console.log(cliente.KUNNR, ultimaFactura, facts)
          facts.forEach(element => {
            cliente.facturas.push(element)
          });
        }
        if (index === array.length -1){
          resolve(flag);
          dispatch({type:"FETCHING_END"})
        }
      });
    });
    getNewFacts.then((response) => {
      if(response){
        dispatch({type:"CLIENTES_FETCHING", payload: { clientes:newData } })
      }
    });
  }
  
  return (
    <>
      <ThemeProvider theme={appliedTheme}>
        <div id='main'>
          <article>    
            <Paper>
              <Root>
                <CssBaseline />
                <CustomAppBar position="fixed" open={open} >
                  <Toolbar style={{alignSelf: "flex-start", }}>
                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      onClick={handleDrawerOpen}
                      edge="start"
                      sx={{marginRight: 2, display: open ? 'none' : 'inline-flex'}}
                    >
                      <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap>
                      {pantalla}
                    </Typography>
                  </Toolbar>
                </CustomAppBar>
                <CustomDrawer
                  variant="persistent"
                  anchor="left"
                  open={open}
                >
                  <DrawerHeader>
                    <IconButton onClick={handleDrawerClose}>
                      {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                  </DrawerHeader>
                  <Divider />
                  <List>
                    {['Inicio', 'Cobranza', 'Clientes', 'Tickets'].map((text, index) => (
                      <ListItem key={text} sx={styles.button} >
                        <ListItemText primary={text} onClick={() => {cambioPantalla(text)}} />
                      </ListItem>
                    ))}
                  </List>
                  <Divider />
                  <List>
                    <ListItem key={'pwsd'} sx={styles.button}>
                        <ListItemText primary={'Contraseña'} onClick={() => {cambioPantalla('Contraseña');}} />
                    </ListItem>
                    <ListItem key={'color'} sx={styles.button}>
                      <FormControlLabel
                        value="start"
                        label="Modo oscuro"
                        labelPlacement="start"
                        control={
                          <Switch
                            color="primary"
                            checked={isDarkMode}
                            onChange={handleThemeToggle}
                          />
                        }
                      />
                    </ListItem>
                    <ListItem key={'salir'} style={{justifyContent: "center", alignItems: "center", display: "flex"}}>
                      <Button variant="contained" color="primary"
                        onClick={() => setOpenSesion(true)}
                      >
                        Cerrar sesión
                      </Button>
                    </ListItem>
                    
                  </List>
                </CustomDrawer>
                <CustomMain open={open}>
                  <DrawerHeader />
                    <div style={{justifyContent: "center", alignItems: "center", display: "flex"}} key="Inicio">
                      {pantalla === 'Inicio'?
                          <div style={{justifyContent: "center", alignItems: "center", display: "block"}}>
                            <div>
                              {syncs.isFetching? 
                              <>
                                  <div style={{display: "flex", justifyContent:"center"}} >
                                    <CircularProgress color="primary" size={300}/>
                                  </div>
                                  <span style={{fontWeight: 'bold', fontSize: 20, alignSelf: "center"}}>Descargando información</span>
                              </>
                              :
                              <>
                              <div>
                                <img className="App-logo" src={logo} alt="logo" height="120" />
                              </div>
                              <div>
                                <span style={{fontSize: 18}}>{`${vendedor && vendedor.vendedor_nombre ?"Hola, "+vendedor.vendedor_nombre: ""}`}</span>
                              </div>
                              <div>
                                <span style={{fontSize: 15}}>{`${vendedor && vendedor.numero_vendedor? "Clave: " + vendedor.numero_vendedor: ""}`}</span>
                              </div>
                              <div>
                                <span style={{fontSize: 15}}>{`${configuracion && configuracion.last_sync? "Ultima actualizacion: " + configuracion.last_sync: ""}`}</span>
                              </div>
                              <br/>
                              <div>
                                <Button variant="contained" color="primary" onClick={() => getInformation()} 
                                disabled={puedeActualizar} 
                                style={{width: '100%'}}>Actualizar información</Button>
                              </div>
                              <br/>
                              <div>
                                <Button variant="contained" color="primary" onClick={() => getFacts()} 
                                disabled={puedeActualizar} 
                                style={{width: '100%'}}>Facturas del día</Button>
                              </div>
                              <span style={{fontSize: 10}}>Versión 1.7.0</span>
                              </>
                              }
                            </div>
                          </div>
                      : pantalla === 'Cobranza'? <Captura key={"Captura"} clienteCobrar={clienteCobrar}/>
                      : pantalla === 'Clientes'? <Clientes key={"Clientes"}theme={theme}/>
                      : pantalla === 'Tickets'? <Tickets key={"Tickets"}/>
                      : pantalla === 'Contraseña'?  <Password key={"Contra"}/>
                      : null}
                    </div> 
                    <div>
                      <Dialog
                        open={openSesion}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        key={"dialogo cerrar"}
                        scroll='paper'
                        disableEscapeKeyDown
                      >
                        <DialogTitle id="alert-dialog-title">Cerrar sesión</DialogTitle>
                        <DialogContent>
                          <DialogContentText id="alert-dialog-description">
                            ¿Deseas cerrar tu sesión? 
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button variant="contained" onClick={async () =>{ await firebase.auth().signOut(); dispatch({type:"RESET_ALL_DATA"})}} color="primary">
                            Sí
                          </Button>
                          <Button variant="contained" onClick={handleClose} color="primary" autoFocus>
                            No
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </div>
                </CustomMain>
              </Root>
              <div style={{height:40}}/>
            </Paper>
          </article>
        </div>    
      </ThemeProvider>
    </>
  );
}
// Aqui se declaran estilos para sustituir prop button
const styles = {
  button: {
    cursor: 'pointer',
    '&:hover': {backgroundColor: 'action.hover'}
  }
};

export const light = {
  palette: {
    mode: "light",
  }
};
export const dark = {
  palette: {
    mode: "dark"
  }
};